module.exports = __webpack_public_path__ + "zip.png?36bf6d8453a1ae80bfd1dafdc822f936";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/attachment-format/zip.png
// module id = 53
// module chunks = 0